import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Stack,
} from "@mui/material";
import updateSheetValues from "../update-google-sheet";
import { useJobCompletion } from "../../JobCompletionContext";

const QuoteServices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { completedJobs, updateCache } = useJobCompletion();

  // Props passed in via navigation state
  const {
    address,
    bucket,
    driver,
    script_id,
    mulchingYards: initialMulchingYards = "",
    weedingHours: initialWeedingHours = "",
    bushTrimmingHours: initialBushTrimmingHours = "",
    fertilizationBags: initialFertilizationBags = "",
  } = location.state || {};

  // Form state
  const [mulchingYards, setMulchingYards] = useState(initialMulchingYards);
  const [weedingHours, setWeedingHours] = useState(initialWeedingHours);
  const [bushTrimmingHours, setBushTrimmingHours] = useState(
    initialBushTrimmingHours
  );
  const [fertilizationBags, setFertilizationBags] = useState(
    initialFertilizationBags
  );
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async () => {
    setSubmitting(true);
    const baseUrl =
      "https://script.google.com/macros/s/AKfycbwz6yaK87LoJE4CWmoodmf-hdEic53ceV6E_sTDUuY1zzvVwseCc3Df9j0OtnrmafuoYw/exec";

    const queryParams = new URLSearchParams({
      address,
      mulchingYards,
      weedingHours,
      bushTrimmingHours,
      fertilizationBags,
    }).toString();

    try {
      const response = await fetch(`${baseUrl}?${queryParams}`, {
        method: "GET",
      });

      const data = await response.json();
      if (data.status === "success") {
        setSuccessMessage("Quote submitted successfully!");
        if (driver && script_id) {
          updateCache(address);
          updateSheetValues(address, "", driver, script_id);
        }

        setTimeout(() => {
          navigate(-1); // Go back to previous page
        }, 1000);
      } else {
        alert("Failed to submit quote. Try again.");
      }
    } catch (error) {
      console.error("Error submitting quote:", error);
      alert("An error occurred.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        fontFamily: "Poppins",
        width: "100%",
        maxWidth: 500,
        margin: "auto",
        // padding: 3,
        minHeight: "100vh",
      }}
    >
      <Paper elevation={3} sx={{ padding: 3 }}>
        <Typography
          variant="h5"
          fontWeight="bold"
          fontFamily="Poppins"
          gutterBottom
        >
          Quote Landscaping Services
        </Typography>

        <Typography
          variant="subtitle1"
          fontWeight="bold"
          fontFamily="Poppins"
          gutterBottom
        >
          {bucket}
        </Typography>

        <Typography variant="body2" gutterBottom>
          Address: {address}
        </Typography>

        {successMessage && (
          <Typography
            variant="body1"
            color="success.main"
            fontFamily="Poppins"
            mb={2}
          >
            {successMessage}
          </Typography>
        )}

        {submitting ? (
          <Typography
            variant="body1"
            color="primary"
            fontFamily="Poppins"
            mb={2}
          >
            Submitting...
          </Typography>
        ) : (
          <Stack spacing={2} mt={2}>
            <TextField
              fullWidth
              label="Mulching (Yards)"
              type="number"
              value={mulchingYards}
              onChange={(e) => setMulchingYards(e.target.value)}
            />
            <TextField
              fullWidth
              label="Weeding (Hours)"
              type="number"
              value={weedingHours}
              onChange={(e) => setWeedingHours(e.target.value)}
            />
            <TextField
              fullWidth
              label="Bush Trimming (Hours)"
              type="number"
              value={bushTrimmingHours}
              onChange={(e) => setBushTrimmingHours(e.target.value)}
            />
            <TextField
              fullWidth
              label="Fertilization (Bags)"
              type="number"
              value={fertilizationBags}
              onChange={(e) => setFertilizationBags(e.target.value)}
            />

            <Button
              variant="contained"
              color="success"
              fullWidth
              onClick={handleSubmit}
            >
              Submit Quote
            </Button>
            <Button
              variant="outlined"
              color="error"
              fullWidth
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
          </Stack>
        )}
      </Paper>
    </Box>
  );
};

export default QuoteServices;
